/* SEO service landing pages content. Each has a dedicated route. */

export const SERVICE_PAGES = [
  {
    slug: "terapia-fisica-pachuca",
    title: "Terapia Física en Pachuca",
    metaTitle: "Terapia Física en Pachuca, Hidalgo · TERAFIQUIRO Wellness Center",
    metaDesc:
      "Clínica de terapia física en Pachuca, Hidalgo. Atendemos lumbalgia, hernia discal, ciática, hombro congelado, tendinitis y rehabilitación post-quirúrgica. Agenda en línea o por WhatsApp.",
    keywords: "terapia fisica pachuca, fisioterapia pachuca, fisioterapeuta pachuca, rehabilitacion pachuca",
    cover: "/img/blog/blog_fisio_quiro.png",
    headline: "Terapia física clínica en Pachuca, Hidalgo",
    subheadline:
      "Recupera tu movilidad sin dolor con terapia física basada en evidencia. Atendemos a deportistas, oficinistas y adultos mayores con planes 100% personalizados.",
    conditions: [
      "Lumbalgia (dolor de espalda baja)", "Cervicalgia y tortícolis",
      "Tendinitis y bursitis", "Esguinces y desgarros musculares",
      "Hombro congelado (capsulitis adhesiva)", "Epicondilitis (codo de tenista)",
      "Síndrome del túnel carpiano", "Fascitis plantar",
      "Hernias discales lumbares y cervicales", "Recuperación post-fractura y post-quirúrgica",
    ],
    techniques: [
      "Termoterapia y crioterapia", "Ultrasonido terapéutico",
      "Aplicación de láser", "Vendaje neuromuscular (Kinesiotape)",
      "Electroterapia y TENS", "Ejercicios terapéuticos progresivos",
      "Corrección postural y de marcha", "Propiocepción y equilibrio",
    ],
    sections: [
      {
        h2: "¿Qué es la terapia física?",
        body: "La terapia física (fisioterapia) es una disciplina clínica respaldada por evidencia científica que se enfoca en restaurar el movimiento, reducir el dolor y prevenir nuevas lesiones. A diferencia del huesero tradicional, el fisioterapeuta realiza una valoración integral (postura, fuerza, rango articular, marcha) y diseña un plan personalizado.",
      },
      {
        h2: "Beneficios de tu primera sesión en Pachuca",
        body: "En tu valoración inicial revisamos historial médico, exploramos rangos de movimiento, identificamos compensaciones musculares y diseñamos tu plan. La mayoría de pacientes nota mejoría desde la 2da o 3ra sesión.",
      },
      {
        h2: "¿Cuántas sesiones necesito?",
        body: "Casos agudos (menos de 2 semanas): 3-6 sesiones. Casos crónicos: 8-12 sesiones + mantenimiento mensual. Siempre te explicamos por qué cada sesión es necesaria antes de comprometerte a un paquete.",
      },
    ],
    cta: { text: "Agendar terapia física", anchor: "#booking-fisio" },
  },
  {
    slug: "quiropractico-pachuca",
    title: "Quiropráctico en Pachuca",
    metaTitle: "Quiropráctico Clínico en Pachuca · Ajustes Diversified · TERAFIQUIRO",
    metaDesc:
      "Quiropráctico clínico en Pachuca, Hidalgo. Ciática, hernias discales, migrañas, dolor cervical y mareos cervicogénicos. Ajustes seguros con técnica Diversified. Agenda ahora.",
    keywords: "quiropractico pachuca, huesero pachuca, quiropractico hidalgo, ajuste quiropractico pachuca",
    cover: "/img/specialties/10_huesero_quiropractica.png",
    headline: "Quiropráctica clínica en Pachuca",
    subheadline:
      "Ajustes vertebrales precisos con evidencia clínica. No somos un huesero tradicional: exploramos, valoramos riesgos y ajustamos con criterio.",
    conditions: [
      "Ciática y dolor lumbar crónico", "Dolor cervical y tortícolis",
      "Migrañas y cefaleas tensionales", "Vértigo y mareos cervicogénicos",
      "Hernias discales lumbares y cervicales", "Síndrome sacroilíaco",
      "Síndrome del piriforme", "Problemas de ATM (mandíbula)",
      "Bloqueos costovertebrales", "Mala postura y escoliosis funcional",
    ],
    techniques: [
      "Exploración quirofísica completa", "Manipulación articular Diversified",
      "Ajustes vertebrales y pélvicos", "Masaje terapéutico complementario",
      "Movilizaciones articulares", "Liberación miofascial",
    ],
    sections: [
      {
        h2: "Quiropráctico vs huesero: la diferencia clave",
        body: "El huesero tradicional ajusta empíricamente sin estudios diagnósticos. El quiropráctico clínico explora primero, valora factores de riesgo (osteoporosis, hipertensión, antecedentes) y aplica técnicas precisas. Es seguro, indoloro y respaldado por evidencia.",
      },
      {
        h2: "¿Cuándo acudir con el quiropráctico?",
        body: "Cuando tienes dolor lumbar o cervical persistente, ciática, migrañas frecuentes, mareos que aparecen al voltear el cuello, o cuando sientes que 'algo está fuera de lugar' en tu columna. También funciona como mantenimiento mensual si usas computadora muchas horas.",
      },
      {
        h2: "¿Es seguro?",
        body: "Sí. Realizamos exploración previa para descartar contraindicaciones. Si encontramos riesgo, te derivamos a estudios de imagen antes de cualquier ajuste. La quiropráctica clínica tiene un perfil de seguridad excelente con profesional certificado.",
      },
    ],
    cta: { text: "Agendar ajuste quiropráctico", anchor: "#booking-fisio" },
  },
  {
    slug: "masaje-deportivo-pachuca",
    title: "Masaje Deportivo y de Descarga en Pachuca",
    metaTitle: "Masaje Deportivo y Masaje de Descarga en Pachuca · TERAFIQUIRO",
    metaDesc:
      "Masaje deportivo y masaje de descarga en Pachuca, Hidalgo. Para corredores, ciclistas, triatletas y deportistas amateurs. Recupera, previene lesiones y mejora tu rendimiento.",
    keywords: "masaje deportivo pachuca, masaje de descarga pachuca, terapia deportiva pachuca, fisioterapia deportiva",
    cover: "/img/specialties/07_masaje_descarga.png",
    headline: "Masaje deportivo y descarga muscular en Pachuca",
    subheadline:
      "Acelera tu recuperación, libera puntos gatillo y vuelve a entrenar más fuerte. Ideal para corredores, ciclistas, triatletas, jugadores de pádel y CrossFit.",
    conditions: [
      "Sobrecarga muscular post-entreno", "Puntos gatillo y contracturas",
      "Tendinitis del corredor", "Codo de tenista / golfista (epicondilitis)",
      "Síndrome de la cintilla iliotibial", "Fascitis plantar del deportista",
      "Tendinopatía aquílea", "Dolor lumbar del ciclista",
    ],
    techniques: [
      "Masaje profundo (deep tissue)", "Técnica de descarga miofascial",
      "Liberación de puntos gatillo", "Estiramiento asistido (PNF)",
      "Vendaje neuromuscular post-masaje", "Drenaje linfático para inflamación",
    ],
    sections: [
      {
        h2: "¿Para qué sirve el masaje de descarga?",
        body: "Después de entrenamientos intensos, tus músculos acumulan tensión, ácido láctico y micro-lesiones. El masaje de descarga libera esa tensión, mejora circulación, reduce DOMS (dolor muscular tardío) y acelera la recuperación entre sesiones de entrenamiento.",
      },
      {
        h2: "¿Cuándo agendar una sesión?",
        body: "Idealmente 24-48 horas después de tu entrenamiento o competencia más intenso. Para deportistas que entrenan 5+ días a la semana, recomendamos 1 sesión semanal de mantenimiento.",
      },
      {
        h2: "Diferencia con masaje relajante",
        body: "El masaje relajante es de presión ligera con fines de bienestar. El masaje deportivo aplica presión profunda en cadenas musculares específicas, identifica y libera puntos gatillo, y se combina con maniobras de fisioterapia.",
      },
    ],
    cta: { text: "Agendar masaje de descarga", anchor: "#booking-fisio" },
  },
  {
    slug: "ozonoterapia-pachuca",
    title: "Ozonoterapia en Pachuca",
    metaTitle: "Ozonoterapia Médica en Pachuca, Hidalgo · TERAFIQUIRO",
    metaDesc:
      "Ozonoterapia médica en Pachuca para dolor articular, hernias discales, fatiga crónica, fortalecimiento inmunológico y enfermedades autoinmunes. Protocolos clínicos seguros.",
    keywords: "ozonoterapia pachuca, ozonoterapia hidalgo, terapia con ozono pachuca",
    cover: "/img/specialties/11_ozonoterapia.png",
    headline: "Ozonoterapia clínica en Pachuca",
    subheadline:
      "Oxígeno terapéutico con más de 70 años de uso médico. Modula tu sistema inmune, reduce inflamación crónica y acelera la recuperación tisular.",
    conditions: [
      "Hernias discales (aplicación intradiscal o paravertebral)", "Dolor articular crónico",
      "Fatiga crónica y bajo rendimiento", "Infecciones recurrentes",
      "Heridas crónicas y úlceras", "Migrañas resistentes a fármacos",
      "Post-COVID prolongado (long COVID)", "Enfermedades autoinmunes",
    ],
    techniques: [
      "Auto-hemoterapia mayor", "Insuflación rectal de ozono",
      "Aplicación intramuscular paravertebral", "Aplicación intradiscal (con guía)",
      "Aceite ozonizado para heridas", "Bolsa de ozono local",
    ],
    sections: [
      {
        h2: "¿Qué es la ozonoterapia médica?",
        body: "El ozono médico (O₃) es una mezcla controlada de oxígeno trivalente que, en dosis precisas, activa enzimas antioxidantes, modula citoquinas inflamatorias y mejora la oxigenación tisular. Está reconocida en Alemania, Italia, Cuba, España y México.",
      },
      {
        h2: "¿Es segura?",
        body: "Sí, cuando se aplica con protocolos correctos por profesional certificado. Antes de cualquier sesión hacemos valoración clínica y análisis básicos. Los efectos secundarios son raros (mareo leve transitorio) y nunca aplicamos ozono por vía inhalatoria.",
      },
      {
        h2: "¿Cuántas sesiones se necesitan?",
        body: "Para dolor agudo: 8-10 sesiones. Para condiciones crónicas: 15-20 sesiones. Notarás mejoría progresiva desde la 4ta-5ta aplicación.",
      },
    ],
    cta: { text: "Consultar ozonoterapia", anchor: "#booking-alt" },
  },
  {
    slug: "medicina-funcional-pachuca",
    title: "Medicina Funcional en Pachuca",
    metaTitle: "Medicina Funcional en Pachuca · Diagnóstico Integrativo · TERAFIQUIRO",
    metaDesc:
      "Medicina funcional en Pachuca. Buscamos las causas reales de fatiga crónica, ansiedad, migrañas, colon irritable, hipotiroidismo subclínico y enfermedades autoinmunes.",
    keywords: "medicina funcional pachuca, medico funcional pachuca, medicina integrativa pachuca, herbolaria adaptogenos",
    cover: "/img/blog/blog_funcional_estetica.png",
    headline: "Medicina funcional en Pachuca",
    subheadline:
      "No tratamos síntomas: encontramos causas. Diagnóstico avanzado (microbioma, perfil hormonal, micronutrientes) combinado con herbolaria, adaptógenos y ozonoterapia.",
    conditions: [
      "Fatiga crónica y fatiga adrenal", "Ansiedad e insomnio",
      "Migrañas recurrentes", "Síndrome de intestino irritable (SII)",
      "Hipotiroidismo subclínico", "Sobrepeso resistente a dieta",
      "Enfermedades autoinmunes en etapa temprana", "Síntomas premenopáusicos",
      "Fibromialgia", "Niebla mental",
    ],
    techniques: [
      "Análisis de microbioma intestinal", "Perfil hormonal completo (cortisol, tiroides, sexual)",
      "Test de micronutrientes y metales pesados", "Plan nutricional anti-inflamatorio",
      "Suplementación dirigida basada en análisis", "Herbolaria clínica y adaptógenos",
      "Combinación con ozonoterapia y terapia neural",
    ],
    sections: [
      {
        h2: "¿Qué es la medicina funcional?",
        body: "Es un enfoque clínico que ve el cuerpo como un sistema interconectado. En lugar de centrarse solo en el órgano que duele, evalúa nutrición, microbiota, hormonas, sistema inmune y estrés. Diseña planes personalizados de fondo, no solo paliativos.",
      },
      {
        h2: "Herbolaria y adaptógenos: ciencia, no moda",
        body: "Trabajamos con ashwagandha, rhodiola, ginseng, reishi, cúrcuma, jengibre y boswellia. Cada uno con evidencia clínica para indicaciones específicas. La diferencia: usamos extractos estandarizados con dosis terapéuticas, no suplementos genéricos.",
      },
      {
        h2: "¿Cuánto dura un protocolo funcional?",
        body: "El plan inicial es a 3-6 meses con revisiones cada 4-6 semanas. Una vez estabilizado, mantenimiento trimestral. Los cambios profundos en metabolismo y microbiota toman tiempo, pero son duraderos.",
      },
    ],
    cta: { text: "Agendar valoración funcional", anchor: "#booking-alt" },
  },
  {
    slug: "tratamientos-faciales-pachuca",
    title: "Tratamientos Faciales en Pachuca",
    metaTitle: "Tratamientos Faciales y Mesoterapia en Pachuca · TERAFIQUIRO",
    metaDesc:
      "Tratamientos faciales en Pachuca: antiedad, lifting, mesoterapia facial, despigmentantes, acné, hidratación profunda y lifting de pestañas. Cosmiatría profesional.",
    keywords: "tratamiento facial pachuca, mesoterapia facial pachuca, facial antiedad pachuca, lifting pestañas pachuca",
    cover: "/img/specialties/09_masaje_facial.png",
    headline: "Tratamientos faciales y estética en Pachuca",
    subheadline:
      "Cosmiatría profesional con protocolos validados. Resultados naturales y honestos: tu piel sana hoy, sana también en 10 años.",
    conditions: [
      "Líneas finas y signos de envejecimiento", "Pérdida de firmeza y tono",
      "Acné activo y secuelas de acné", "Manchas, melasma y daño solar",
      "Piel seca y deshidratada", "Piel sensible y rosácea leve",
      "Ojeras y mirada cansada", "Pestañas caídas o sin definición",
    ],
    techniques: [
      "Facial antiedad con efecto lifting", "Mesoterapia facial con hialurónico",
      "Peeling químico controlado", "Tratamientos despigmentantes",
      "Hidratación profunda para piel sensible", "Lifting de pestañas con queratina",
      "Diseño y micropigmentación de cejas",
    ],
    sections: [
      {
        h2: "Mesoterapia facial: rejuvenecimiento sin cirugía",
        body: "Consiste en micro-inyecciones intradérmicas de ácido hialurónico, vitaminas y aminoácidos. Aumenta hidratación profunda, estimula colágeno y mejora textura, luminosidad y elasticidad. Resultados visibles desde la 2da sesión.",
      },
      {
        h2: "Protocolo antiedad personalizado",
        body: "Evaluamos tu tipo de piel, hábitos, edad biológica y metas reales. Combinamos radiofrecuencia, masaje esculpido, peeling controlado y mesoterapia. Sin promesas mágicas: trabajamos con resultados medibles documentados.",
      },
      {
        h2: "Acné y manchas: protocolos honestos",
        body: "Para acné activo combinamos limpieza profunda, LED azul, peeling salicílico y manejo de barrera cutánea. Para manchas (melasma, post-inflamatorias) usamos despigmentantes profesionales + fotoprotección estricta. Es un proceso de meses, no de días.",
      },
    ],
    cta: { text: "Agendar valoración cosmiátrica", anchor: "#booking-estetica" },
  },
];
